/**
 * External links in new tab
 * Any absolute http(s) link whose hostname is not ours gets target="_blank" and
 * rel="noopener noreferrer". Runs once after DOM is parsed, then a MutationObserver
 * picks up links injected later by Shopify Section Rendering API (mega-menu, etc.).
 */
(function () {
  var INTERNAL_HOSTS = [
    'soundsgood.cz', 'soundsgood.agency', 'podnikat-online.myshopify.com',
    'localhost', '127.0.0.1'
  ];

  function isInternalHost(hostname) {
    return INTERNAL_HOSTS.some(function (h) {
      return hostname === h || hostname.endsWith('.' + h);
    });
  }

  function stampLink(link) {
    try {
      var url = new URL(link.href, window.location.href);
      if (
        (url.protocol === 'http:' || url.protocol === 'https:') &&
        !isInternalHost(url.hostname)
      ) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    } catch (e) {
      // unparseable href (shopify://, relative, #anchor) — skip
    }
  }

  // Initial pass — covers all static HTML links
  function applyExternalLinkAttributes() {
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      stampLink(links[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyExternalLinkAttributes);
  } else {
    applyExternalLinkAttributes();
  }

  // MutationObserver — covers links injected after initial pass
  // (Shopify Section Rendering API, mega-menu, live chat widgets, etc.)
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.tagName === 'A' && node.href) stampLink(node);
        var children = node.querySelectorAll ? node.querySelectorAll('a[href]') : [];
        for (var k = 0; k < children.length; k++) stampLink(children[k]);
      }
    }
  });

  var root = document.body || document.documentElement;
  observer.observe(root, { childList: true, subtree: true });
})();
